<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';

export default{
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'isDisabled'],

  components: {
    Button,
},
  data(){
    return {
      data: {},
    }
  },
  validations(){
    return {
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.config = config.getConfiguration('VesselProtocol').previsionalCommercialInfo;
  },
  mounted(){
    this.loadData();
  },
  watch: {
    
  },
  methods: {
    loadData(){
      this.$store.dispatch("generic/setLoading", true);
      Service.getVesselProtocolPrevisionalCommercialInfo(this.vesselProtocolId, ({success, data, notFound, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        if(success && data){
          this.data = data;
          this.data.documentDate = new Date(this.utils.dateToCurrentTimeZone(data.documentDate));
          this.data.documentReproportionedTotalAmountCheck = true;
          this.data.rentalReproportionedTotalAmountCheck = true;
          this.data.insuranceReproportionedTotalAmountCheck = true;
          this.data.otherCostsReproportionedTotalAmountCheck = true;
        } else if(!notFound){
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    updateData(){
      this.data.idVesselProtocol = this.vesselProtocolId;
      this.$store.dispatch("generic/setLoading", true);

      if(this.data.id){
        Service.updateVesselProtocolPrevisionalCommercialInfo(this.data, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);

          if(success){
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      } else {
        Service.addVesselProtocolPrevisionalCommercialInfo(this.data, ({success, message}) => {
          this.$store.dispatch("generic/setLoading", false);

          if(success){
            this.loadData();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    },
    calculateValue(calculationType){
      this.$store.dispatch("generic/setLoading", true);
      this.data.idVesselProtocol = this.vesselProtocolId;
      Service.calculateVesselProtocolPCI({calculationType, data: this.data}, ({success, data, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        if(success){
          const documentDate = this.data.documentDate;
          this.data = data;
          this.data.documentDate = documentDate;
        } else {
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    }
  },
}

</script>

<template>
  <main>
    <div class="grid">
      <div class="col-12">
        <Toolbar>
          <template #start>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="updateData" :disabled="!uiPermissions('vesselProtocolPCISaveButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolPCISaveButton').isHidden" />
          </template>
        </Toolbar>
      </div>
      <div v-for="fieldset in config.fieldsets" class="col-12" :key="fieldset">
        <Fieldset :legend="$t(fieldset.label)" class="h-100">
          <div class="grid">
            <template v-for="field in fieldset.fields" :key="field">
              <template v-if="!field.hidden">
                <div class="col-12 lg:col-6">
                  <label v-tooltip="$t('vesselProtocol.' + field.label)" class="short-label">
                    {{ $t('vesselProtocol.' + field.label) }}
                  </label>
                  <label class="d-block" v-if="field.readOnly">
                    {{ (data[field.name] ?? '-') }}
                  </label>
                  <template v-else>
                    <Dropdown
                      v-if="field.type == 'dropdown'"
                      :options="field.options" 
                      v-model="data[field.name]"
                      class="w-full p-inputtext-sm m-1" />
                    <InputText 
                      v-if="field.type == 'text'"
                      v-model="data[field.name]"
                      type="text"
                      :readonly="field.readOnly"
                      class="w-full p-inputtext-sm m-1" />
                    <InputNumber
                      v-if="field.type == 'number'"
                      v-model="data[field.name]"
                      :readonly="field.readOnly"
                      class="w-full p-inputtext-sm m-1" />
                    <InputNumber
                      v-if="field.type == 'decimal'"
                      mode="decimal" :maxFractionDigits="field.digits"
                      v-model="data[field.name]"
                      :readonly="field.readOnly"
                      class="w-full p-inputtext-sm m-1" />
                    <Calendar
                      :dateFormat="constants.DATE_FORMAT_POINT"
                      :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                      v-if="field.type == 'date'"
                      v-model="data[field.name]"
                      class="w-full p-inputtext-sm m-1" />
                    <template v-if="field.recalculable">
                      <label :for="field.name + 'Check'">{{ $t('vesselProtocol.toBeReproportioned') }}</label>
                      <Checkbox 
                        :binary="true"
                        :name="field.name + 'Check'"
                        v-model="data[field.name + 'Check']"
                        class="ml-2" />
                    </template>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="col-12 lg:col-6">
                </div>
              </template>
            </template>
          </div>
          <div class="grid">
            <div class="col-12 text-center">
              <template v-for="button in fieldset.buttons" :key="button">
                <Button :label="$t(button.label)" :icon="button.icon" @click="button.action(data, this)" class="mr-2" />
              </template>
            </div>
          </div>
        </Fieldset>
      </div>
      <div class="col-12">
        <label v-tooltip="$t('vesselProtocol.notes')" class="short-label">
          {{ $t('vesselProtocol.notes') }}
        </label>
        <Textarea
          v-model="data.notes"
          class="w-full m-1 h-10rem" />
      </div>
    </div>
  </main>
</template>

<style scoped>

.short-label {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.h-100 {
  height: 100%;
}

.d-block {
  display: block;
}
</style>